var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-delete_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.23 4.1h-4.36v-.26c0-2.12-1.72-3.85-3.85-3.85H8.97c-2.12 0-3.85 1.72-3.85 3.85v.26H.77c-.42 0-.77.35-.77.77s.35.77.77.77h1.28v9.49A4.87 4.87 0 0 0 6.92 20h6.15a4.87 4.87 0 0 0 4.87-4.87V5.64h1.28c.42 0 .77-.35.77-.77s-.35-.77-.77-.77zM6.67 3.85c0-1.27 1.04-2.31 2.31-2.31h2.05c1.27 0 2.31 1.04 2.31 2.31v.26H6.67zm9.74 11.28c0 1.84-1.5 3.33-3.33 3.33H6.93c-1.84 0-3.33-1.5-3.33-3.33V5.64h12.82v9.49z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 8.25c-.41 0-.75.34-.75.75v6c0 .41.34.75.75.75s.75-.34.75-.75V9c0-.41-.34-.75-.75-.75M13 8.25c-.41 0-.75.34-.75.75v6c0 .41.34.75.75.75s.75-.34.75-.75V9c0-.41-.34-.75-.75-.75M7 8.25c-.41 0-.75.34-.75.75v6c0 .41.34.75.75.75s.75-.34.75-.75V9c0-.41-.34-.75-.75-.75"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-delete_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgIcDelete;